import { render, staticRenderFns } from "./BannerBlog.vue?vue&type=template&id=1891ca1b&scoped=true&"
import script from "./BannerBlog.vue?vue&type=script&lang=js&"
export * from "./BannerBlog.vue?vue&type=script&lang=js&"
import style0 from "./BannerBlog.vue?vue&type=style&index=0&id=1891ca1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1891ca1b",
  null
  
)

export default component.exports